import { apiClient } from "../api/apiClient";
import { OccasionType, CreateOccasionTypeRequest, UpdateOccasionTypeRequest } from "../interfaces/OccasionType";

type ResponseDto<T> = {
  loggingHistoryID?: number;
  statusCode: number;
  isSuccess: boolean;
  message: string;
  errors?: string[];
  data?: T;
  dataList?: T[];
};

export const occasionTypeService = {
getAll: async (): Promise<ResponseDto<OccasionType>> => {
  const response = await apiClient.get<ResponseDto<OccasionType>>("/OccasionTypes/GetActiveAll");
  return response.data;
},
  getById: async (occasionTypeID: number): Promise<ResponseDto<OccasionType>> => {
    const response = await apiClient.get<ResponseDto<OccasionType>>(`/OccasionTypes/GetById/${occasionTypeID}`);
    return response.data;
  },
  create: async (payload: CreateOccasionTypeRequest): Promise<ResponseDto<OccasionType>> => {
    const response = await apiClient.post<ResponseDto<OccasionType>>("/OccasionTypes/Create", payload);
    return response.data;
  },
  update: async (payload: UpdateOccasionTypeRequest): Promise<ResponseDto<OccasionType>> => {
    const response = await apiClient.put<ResponseDto<OccasionType>>(`/OccasionTypes/Update/${payload.occasionTypeID}`, payload);
    return response.data;
  },
  delete: async (occasionTypeID: number): Promise<ResponseDto<any>> => {
    const response = await apiClient.delete<ResponseDto<any>>(`/OccasionTypes/Delete/${occasionTypeID}`);
    return response.data;
  },
};
